import React, { ReactElement, useEffect, useState } from 'react';
import { Form, FormInstance } from 'antd';
import { RcFile } from 'antd/lib/upload';

import { setFileUploadedToBase64 } from 'pricing/utilities/media/setFileUploadedToBase64/setFileUploadedToBase64';
import FieldFileUploadPreviewer from 'pricing/components/contract/contractForm/fields/fieldFileUpload/components/FieldFileUploadPreviewer';
import FieldFileUploader from 'pricing/components/contract/contractForm/fields/fieldFileUpload/components/FieldFileUploader';
import { FieldFileUploadFrame } from './FieldFileUpload.styles';

export interface FilePreview {
  src: string | undefined;
  isImage: boolean;
  isPdf: boolean;
}

interface Props {
  name: string;
  form: FormInstance;
  disabled?: boolean;
}

function FieldFileUpload(props: Props): ReactElement {
  const { name, form, disabled } = props;
  const [filePreview, setFilePreview] = useState<FilePreview>();

  const normalizingFileUpload = (event: { target: { files: RcFile[] } }) => {
    return event.target.files[0];
  };

  const handleSetFilePreview = (file: string | RcFile) => {
    if (!file) {
      setFilePreview({
        src: '',
        isImage: false,
        isPdf: false,
      });
      form.validateFields([name]);
      return;
    }
    if (typeof file === 'string') {
      setFilePreview({
        src: file,
        isImage: !file.includes('.pdf'),
        isPdf: file.includes('.pdf'),
      });
    } else {
      setFileUploadedToBase64(file, (base64: string | ArrayBuffer | null) => {
        setFilePreview({
          src: base64 as string,
          isImage: file.type.includes('image'),
          isPdf: file.type.includes('pdf'),
        });
      });
    }
  };

  useEffect(() => {
    return () => {
      setFilePreview({
        src: '',
        isImage: false,
        isPdf: false,
      });
    };
  }, []);

  return (
    <Form.Item
      shouldUpdate={(prevValues, curValues) => {
        if (prevValues[name] !== curValues[name]) {
          handleSetFilePreview(curValues[name]);
        }
        return prevValues[name] !== curValues[name];
      }}
    >
      {() => (
        <Form.Item
          name={name}
          valuePropName="fileList"
          getValueFromEvent={normalizingFileUpload}
          noStyle
          rules={[{ required: true, message: 'This field is required' }]}
        >
          <FieldFileUploadFrame>
            {filePreview?.src ? (
              <FieldFileUploadPreviewer
                formItemName={name}
                filePreview={filePreview}
                form={form}
                disabled={disabled}
              />
            ) : (
              <FieldFileUploader />
            )}
          </FieldFileUploadFrame>
        </Form.Item>
      )}
    </Form.Item>
  );
}

export default FieldFileUpload;
